import { render, staticRenderFns } from "./ip_stream_channels.vue?vue&type=template&id=21182d8e&scoped=true&"
import script from "./ip_stream_channels.vue?vue&type=script&lang=ts&"
export * from "./ip_stream_channels.vue?vue&type=script&lang=ts&"
import style0 from "./ip_stream_channels.vue?vue&type=style&index=0&id=21182d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21182d8e",
  null
  
)

export default component.exports